<div class="image-capture">
  <div>
    <h1 class="image-capture__heading nova-heading-24">
      {{ `${t9nPrefix()}.heading` | translate }}
    </h1>
    <p class="image-capture__subheading nova-body-large">
      {{ `${t9nPrefix()}.subheading` | translate }}
    </p>
  </div>
  <div class="image-capture__misnap-video-container" id="misnap-container">
    <div id="misnap-video" class="image-capture__misnap-video"></div>
  </div>
  @if (hintText()) {
    <p class="image-capture__bottom-text nova-body-medium">
      {{ hintText() }}
    </p>
  }
  <button
    class="image-capture__help-button"
    novaButton
    appTrackedButton
    [trackId]="'id-capture:need-help'"
    variant="tertiary"
    (click)="helpDialog.open()"
  >
    {{ "id-verification.needHelp.buttonText" | translate }}
  </button>
</div>

<app-simple-dialog
  [title]="'id-verification.needHelp.dialogTitle' | translate"
  [analyticsPrefix]="'id-capture:help-dialog'"
  #helpDialog
>
  <p>
    {{ "id-verification.needHelp.dialogContent" | translate }}
    <a
      novaLink
      variant="simple"
      appTrackedLink
      [trackId]="'id-capture:help-dialog:call-support'"
      href="tel:{{ supportPhoneNumber }}"
      >{{ supportPhoneNumber }}</a
    >.
  </p>
</app-simple-dialog>
